import React from 'react'
import { Link } from 'react-router-dom'
import { FiArrowRight } from 'react-icons/fi'
import './aboutUs.css'
import defaultAboutImage from '../../assets/hero4.jpg'
import { ABOUT_BODY, ABOUT_TITLE, HERO_CTA_LABEL } from '../../constants/brand'

const ABOUT_ALT = 'Luxistt furnished apartment interior'

const AboutUs = ({ aboutImageUrl }) => {
  const src = aboutImageUrl && String(aboutImageUrl).trim() ? aboutImageUrl : defaultAboutImage

  return (
    <section className="about-us">
      <div className="about-us-content">
        <div className="content-container">
          <h2>{ABOUT_TITLE}</h2>
          <p>{ABOUT_BODY}</p>
          <Link to="/rooms" className="about-us-cta">
            <span className="about-us-cta-label">{HERO_CTA_LABEL}</span>
            <span className="about-us-cta-icon" aria-hidden>
              <FiArrowRight />
            </span>
          </Link>
        </div>
      </div>
      <div className="about-us-img" style={{ backgroundImage: `url(${src})` }}>
        <img width="100%" height="100%" src={src} alt={ABOUT_ALT} />
      </div>
    </section>
  )
}

export default AboutUs